import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import InternalTemplate from 'components/InternalTemplate';
import PrivateRoute from 'components/PrivateRoute';
import {
  routes, commonRoutes,
} from './routes';

const renderWithTemplate = (component) => () => {
  const RouteComponent = component;
  return (
    <InternalTemplate>
      <RouteComponent />
    </InternalTemplate>
  );
};

const Router = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <BrowserRouter basename="/docs">
      <Switch>
        {commonRoutes.map((route) => (
          <Route
            key={route.path}
            exact={route.exact}
            path={route.path}
            component={route.component}
          />
        ))}
        {routes.map((route) => (
          <PrivateRoute
            isAuthenticated={isAuthenticated}
            key={route.path}
            exact={route.exact}
            path={route.path}
            render={renderWithTemplate(route.component)}
          />
        ))}
      </Switch>
    </BrowserRouter>
  );
};
export default Router;
